import React from 'react'
import dynamic from 'next/dynamic'

const componentsMap = {
  Element: dynamic<any>(() => import('../Element').then((mod) => mod.Element)),
  Footer: dynamic<any>(() => import('../Footer').then((mod) => mod.Footer)),
  MenuLayout: dynamic<any>(() =>
    import('../MenuLayout').then((mod) => mod.MenuLayout)
  ),
  Navbar: dynamic<any>(() => import('../Navbar').then((mod) => mod.Navbar)),
  Banner: dynamic<any>(() => import('../Banner').then((mod) => mod.Banner)),
  TopMobileBanner: dynamic<any>(() =>
    import('../TopMobileBanner').then((mod) => mod.TopMobileBanner)
  ),
  CategoriesMobileCarousel: dynamic<any>(() =>
    import('../CategoriesMobileCarousel').then(
      (mod) => mod.CategoriesMobileCarousel
    )
  ),
  ShopByAge: dynamic<any>(() =>
    import('../ShopByAge').then((mod) => mod.ShopByAge)
  ),
  ShopByCharacters: dynamic<any>(() =>
    import('../ShopByCharacters').then((mod) => mod.ShopByCharacters)
  ),
  ProductPage: dynamic<any>(() =>
    import('../ProductPage').then((mod) => mod.ProductPage)
  ),
  ProductsCarousel: dynamic<any>(() =>
    import('../ProductsCarousel').then((mod) => mod.ProductsCarousel)
  ),
  FooterButtons: dynamic<any>(() =>
    import('../FooterButtons').then((mod) => mod.FooterButtons)
  ),
  ListingPage: dynamic<any>(() =>
    import('../ListingPage').then((mod) => mod.ListingPage)
  ),
  GlobalStyles: dynamic<any>(() =>
    import('../GlobalStyles').then((mod) => mod.GlobalStyles)
  ),
  CategoriesBanner: dynamic<any>(() =>
    import('../CategoriesBanner').then((mod) => mod.CategoriesBanner)
  ),
  Profile: dynamic<any>(() => import('../Profile').then((mod) => mod.Profile)),
  Title: dynamic<any>(() => import('../Title').then((mod) => mod.Title)),
  ResetPassword: dynamic<any>(() =>
    import('../ResetPassword').then((mod) => mod.ResetPassword)
  ),
  Checkout: dynamic<any>(() =>
    import('../Checkout').then((mod) => mod.Checkout)
  ),
  Basket: dynamic<any>(() => import('../Basket').then((mod) => mod.Basket)),
  Favorites: dynamic<any>(() =>
    import('../Favorites').then((mod) => mod.Favorites)
  ),
  SeoModule: dynamic<any>(() =>
    import('../SeoModule').then((mod) => mod.SeoModule)
  ),
  ContactsPage: dynamic<any>(() =>
    import('../ContactsPage').then((mod) => mod.ContactsPage)
  ),
  Faq: dynamic<any>(() => import('../Faq').then((mod) => mod.Faq)),
  SubscribeForNewsletter: dynamic<any>(() =>
    import('../SubscribeForNewsletter').then(
      (mod) => mod.SubscribeForNewsletter
    )
  ),
  Stores: dynamic<any>(() => import('../Stores').then((mod) => mod.Stores)),
  Html: dynamic<any>(() => import('../Html').then((mod) => mod.Html)),
  Order: dynamic<any>(() => import('../Order').then((mod) => mod.Order)),
  BrandsComponent: dynamic<any>(() =>
    import('../Brands').then((mod) => mod.BrandsComponent)
  ),
  Brands: dynamic<any>(() =>
    import('../Brands').then((mod) => mod.BrandsComponent)
  ),
  CookieConsent: dynamic<any>(() =>
    import('../CookieConsent').then((mod) => mod.CookieConsent)
  ),
  PaymentReturn: dynamic<any>(() =>
    import('../PaymentReturn').then((mod) => mod.PaymentReturn)
  ),
  Brochure: dynamic<any>(() =>
    import('../Brochure').then((mod) => mod.Brochure)
  ),
  ErrorPage: dynamic<any>(() =>
    import('../ErrorPage').then((mod) => mod.ErrorPage)
  ),
  BlogPage: dynamic<any>(() =>
    import('../BlogPage').then((mod) => mod.BlogPage)
  ),
  BrandsCarousel: dynamic<any>(() =>
    import('../BrandsCarousel').then((mod) => mod.BrandsCarousel)
  ),
  ResponsiveRow: dynamic<any>(() =>
    import('../ResponsiveRow').then((mod) => mod.ResponsiveRow)
  ),
}

const renderNode = (node: any) => {
  const componentName =
    node.type === 'template'
      ? node.component.componentName
      : node.component.name

  const LazyComponent = componentsMap[componentName]

  if (!LazyComponent) return null

  return (
    <LazyComponent key={node?.id} {...(node?.component.data || {})}>
      {node?.children?.map(renderNode)}
    </LazyComponent>
  )
}

export const RenderComponents = ({ nodes }: { nodes?: any[] }) => {
  return <>{nodes?.map(renderNode)}</>
}
